import React, { useState } from 'react';

import TodayOrder from './TodayOrder';  // Import the TodayOrder component
import OrderHistory from './OrderHistory';  // Import the OrderHistory component

import './css/Order.css';  // Assuming you have a CSS file for styling this component

const Order = ({ userId }) => {
  const [activeSubTab, setActiveSubTab] = useState('currentOrder');  // State to track the current sub-tab

  return (
    <div className="order-container" >
      <div className="sub-tab-container" >
        <h3 
          className={`sub-tab-heading ${activeSubTab === 'currentOrder' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('currentOrder')}
        >
          Order
        </h3>
        <h3 
          className={`sub-tab-heading ${activeSubTab === 'orderHistory' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('orderHistory')}
        >
          Order History
        </h3>
        
      </div>
      <div className="sub-tab-content" style={{backgroundColor:'#ffffff'}}>
        {activeSubTab === 'currentOrder' && (
          <div>
            {/* Render the TodayOrder component when the "Order" tab is active */}
            <TodayOrder userId={userId} />  
          </div>
        )}
        {activeSubTab === 'orderHistory' && (
          <div>
            {/* Render the OrderHistory component when the "Order History" tab is active */}
            <OrderHistory userId={userId} />
          </div>
        )}
        
      </div>
    </div>
  );
};

export default Order;
